import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { SKIP_TENANT_HEADERS } from '@core/http/public-catalog-http.context';
import { OperatedTenantSafetyService } from '@core/tenant/operated-tenant-safety.service';
import { isTenantWriteRequest } from '@core/tenant/operated-tenant-write.utils';
import { switchMap, throwError } from 'rxjs';

/**
 * Antes de la primera mutación en un tenant operado (superadmin), pide confirmación.
 */
export const operatedTenantWriteInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(SKIP_TENANT_HEADERS)) {
    return next(req);
  }

  const safety = inject(OperatedTenantSafetyService);
  if (!safety.isOperatingForeignTenant() || safety.hasWriteAck()) {
    return next(req);
  }
  if (!isTenantWriteRequest(req)) {
    return next(req);
  }

  return safety.confirmWrite().pipe(
    switchMap((ok) => {
      if (ok) {
        return next(req);
      }
      return throwError(
        () =>
          new HttpErrorResponse({
            status: 0,
            statusText: 'Operated tenant write cancelled',
            url: req.url,
          })
      );
    })
  );
};
